<div class="grid grid-cols-2 md:grid-cols-3 grid-rows-2 h-full gap-5  ">

    <a class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize">
        <div class="relative z-[1] h-full flex flex-col justify-between">
            <p class="text-sm font-semibold text-zinc-500">total student</p>
            <h2 class="text-4xl mt-2 font-bold">15,948</h2>
        </div>
        <div class="absolute -bottom-8 -right-8">
            <span class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"><i class="ri-graduation-cap-line"></i></span>
        </div>
    </a>

    <a class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize">
        <div class="relative z-[1] h-full flex flex-col justify-between">
            <p class="text-sm font-semibold text-zinc-500">total course</p>
            <h2 class="text-4xl mt-2 font-bold">5</h2>
        </div>
        <div class="absolute -bottom-8 -right-8">
            <span class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"><i class="ri-book-shelf-line"></i></span>
        </div>
    </a>

    <a class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize">
        <div class="relative z-[1] h-full flex flex-col justify-between">
            <p class="text-sm font-semibold text-zinc-500">total batches</p>
            <h2 class="text-4xl mt-2 font-bold">3</h2>
        </div>
        <div class="absolute -bottom-8 -right-8">
            <span class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"><i class="ri-group-line"></i></span>
        </div>
    </a>

    <a class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize">
        <div class="relative z-[1] h-full flex flex-col justify-between">
            <p class="text-sm font-semibold text-zinc-500">total teachers</p>
            <h2 class="text-4xl mt-2 font-bold">10</h2>
        </div>
        <div class="absolute -bottom-8 -right-8">
            <span class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"><i class="ri-glasses-line"></i></span>
        </div>
    </a>

    <a class="bg-white rounded-lg border0 w-full p-5 border relative overflow-hidden capitalize">
        <div class="relative z-[1] h-full flex flex-col justify-between">
            <p class="text-sm font-semibold text-zinc-500">total departments</p>
            <h2 class="text-4xl mt-2 font-bold">4</h2>
        </div>
        <div class="absolute -bottom-8 -right-8">
            <span class="w-32 h-32 text-4xl rounded-full bg-primary-50 text-primary-600 flex items-center justify-center"><i class="ri-git-merge-line"></i></span>
        </div>
    </a>




</div>
